var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17.514,
    viewBox: "0 0 22 17.514",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M794.812,540.544H777.038a2.115,2.115,0,0,0-2.113,2.113v13.288a2.115,2.115,0,0,0,2.113,2.113h17.774a2.115,2.115,0,0,0,2.113-2.113V542.657A2.115,2.115,0,0,0,794.812,540.544Zm-17.762,1.327h17.762l.03,0-8.646,6.6Zm6.5,6.332,2.666,1.926,2.575-1.967,6.185,8.549a.685.685,0,0,1-.166.021H777.038a.7.7,0,0,1-.256-.053Zm-1.077-.778-6.224,7.789V542.932Zm7.372-.069,5.75-4.389V555.3Z",
    transform: "translate(-774.925 -540.544)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email.4af4ca22.svg";
export { ForwardRef as ReactComponent };